import * as tslib_1 from "tslib";
import 'moment-timezone';
import { OnDestroy, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateFacade, Setting, } from '@app-state';
import { ChartTooltipTrigger } from '@components/ui-chart/base-chart.types';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { Interval, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_TRANSACTION_INTERVALS, intervalToUnit, unitToFormat, } from '@pages/shared/chart.config';
import { ChartColorService, ChartService, ResourceMapperService, StorageService, TransactionService, } from '@services';
import { unsubscribe } from '@utils/object.utils';
import * as moment from 'moment';
import { BehaviorSubject, } from 'rxjs';
var TransactionChartModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TransactionChartModalComponent, _super);
    function TransactionChartModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ChartTooltipTrigger = ChartTooltipTrigger;
        _this.defaultTransactionIntervals = DEFAULT_TRANSACTION_INTERVALS;
        _this.chart = {
            loading$: new BehaviorSubject(true),
            hasData: false,
            data: null,
            legend: null,
            labels: null,
            colors: [],
        };
        _this._labelFormat = '';
        _this._appState = _this._injector.get(AppStateFacade);
        _this._chartService = _this._injector.get(ChartService);
        _this._transactionService = _this._injector.get(TransactionService);
        _this._translateService = _this._injector.get(TranslateService);
        _this._storageService = _this._injector.get(StorageService);
        _this._router = _this._injector.get(Router);
        _this._chartColorService = _this._injector.get(ChartColorService);
        return _this;
    }
    Object.defineProperty(TransactionChartModalComponent.prototype, "labelFormat", {
        get: function () {
            return this._labelFormat;
        },
        set: function (value) {
            this._labelFormat = unitToFormat(value);
        },
        enumerable: true,
        configurable: true
    });
    TransactionChartModalComponent.prototype.ngOnInit = function () {
        this.chart.colors = this._chartColorService.transactions;
        var userId = this._appState.user.value.id;
        this._intervalCacheKey = this._router.url + " chart - " + userId + " - Transactions";
        this.transactionInterval = this._storageService.get(this._intervalCacheKey, Interval.Hour);
        this._loadTransactionStats(this.transactionInterval, this.context.data.id);
    };
    TransactionChartModalComponent.prototype.ngOnDestroy = function () {
        unsubscribe(this._translationSub, this._statSub);
    };
    TransactionChartModalComponent.prototype.onIntervalChange = function (interval) {
        // if not filter is saved in localStorage, use the default
        this.transactionInterval = interval != null ? interval : this.transactionInterval;
        this._loadTransactionStats(this.transactionInterval, this.context.data.id);
        this._storageService.set(this._intervalCacheKey, this.transactionInterval);
    };
    // tslint:disable-next-line:member-ordering
    TransactionChartModalComponent.prototype.onRefreshClick = function () {
        this._loadTransactionStats(this.transactionInterval, this.context.data.id);
    };
    TransactionChartModalComponent.prototype._loadTransactionStats = function (interval, queueId) {
        var _this = this;
        this.labelFormat = intervalToUnit(interval);
        this.chart.hasData = false;
        this.chart.loading$.next(true);
        this.intervalLabel = this._chartService.getTransactionsLabelForInterval(this.transactionInterval);
        this._statSub = this._transactionService
            .getTransactionStats(interval, queueId)
            .subscribe(function (res) {
            _this._generateTransactionChart(res);
        });
    };
    TransactionChartModalComponent.prototype._generateTransactionChart = function (result) {
        var _this = this;
        this.averageTime = result.averageTime;
        // Chart lines are rendered in the order that they are in this array. Reverse them so the totals line is rendered
        // first, not last (i.e. so it no longer covers the other lines).
        result.chartData.reverse();
        var transactionTypes = result.chartData
            .map(function (entry) { return ResourceMapperService.transactionStatus[entry.label]; });
        this.chart.legend = [];
        this.chart.data = [];
        if (this._translationSub) {
            this._translationSub.unsubscribe();
        }
        result.chartData.forEach(function (chartData) {
            _this.chart.data.push(chartData.data);
        });
        this._translationSub = this._translateService.stream(transactionTypes)
            .subscribe(function (translations) {
            _this.chart.data.forEach(function (_entry, idx) {
                _this.chart.legend[idx] = translations[transactionTypes[idx]];
            });
        });
        this.chart.labels = result
            .chartLabels
            .map(function (label) { return moment(label)
            .tz(_this._appState.settings.get(Setting.timezone))
            .format(_this.labelFormat); });
        this.chart.hasData = result.hasData;
        this.chart.loading$.next(false);
    };
    return TransactionChartModalComponent;
}(UiModalComponent));
export { TransactionChartModalComponent };
